import { Component } from '@angular/core';

@Component({
  selector: 'apex-split-dialog',
  templateUrl: './split-dialog.component.html',
})
export class SplitDialogComponent {}
